import { __extends } from "tslib";
import Manager from '../Abstracts/Manager';
import Application from '../../../Architecture/Core/Application';
import { Platform } from 'react-native';
import Managers from '../Constants/Managers';
var NavigationManager = /** @class */ (function (_super) {
    __extends(NavigationManager, _super);
    /* CONSTRUCTOR */
    function NavigationManager() {
        var _this = _super.call(this) || this;
        // History
        _this.init();
        // Routing
        _this.route = "/";
        // Bindings
        _this.init = _this.init.bind(_this);
        _this.navigate = _this.navigate.bind(_this);
        _this.handleOpenURL = _this.handleOpenURL.bind(_this);
        _this.navigateToRoot = _this.navigateToRoot.bind(_this);
        _this.navigateToPrevious = _this.navigateToPrevious.bind(_this);
        return _this;
    }
    /* METHODS */
    NavigationManager.prototype.init = function () {
        if (Platform.OS == "web") {
            this.history = require('history').createBrowserHistory();
        }
        else {
            this.history = require('history').createMemoryHistory();
        }
    };
    NavigationManager.prototype.clear = function () {
        this.history.entries[0] = this.history.entries[this.history.length - 1];
        this.history.entries.length = 1;
        this.history.length = 1;
        Application.current.resolve(Managers.LANGUAGE_MANAGER).checkLanguage();
    };
    NavigationManager.prototype.navigate = function (route, push, data, clear) {
        if (push === void 0) { push = true; }
        if (push) {
            this.history.push("/" + Application.current.resolve(Managers.LANGUAGE_MANAGER).language + route, data);
        }
        else {
            this.history.replace("/" + Application.current.resolve(Managers.LANGUAGE_MANAGER).language + route, data);
        }
        if (clear) {
            this.clear();
        }
        this.route = this.history.location.pathname;
    };
    NavigationManager.prototype.navigateToPrevious = function (data, numberOfPages) {
        if (numberOfPages === void 0) { numberOfPages = 1; }
        if (this.history.length > 0) {
            for (var i = 0; i < numberOfPages; i++) {
                this.history.goBack();
                //It's done because sometimes the replace is adding 'undefined' in entries.
                if (this.history.location == undefined) {
                    while (this.history.location == undefined) {
                        this.history.goBack();
                    }
                    //It's seems that after the while we need still to do a go back.
                    //FIXME: Change to the new version of history to see if the problem is resolved.
                    this.history.goBack();
                }
            }
            if (data != {} && data != undefined) {
                this.history.location.state = data;
            }
            this.route = this.history.location.pathname;
            return true;
        }
        return false;
    };
    NavigationManager.prototype.navigateToRoot = function (route, data, clear) {
        if (route === void 0) { route = ""; }
        if (route == '') {
            this.history.go(this.history.length - 1);
            Application.current.resolve(Managers.LANGUAGE_MANAGER).checkLanguage();
        }
        else {
            this.navigate(route, true, data, clear);
        }
        this.route = this.history.location.pathname;
    };
    NavigationManager.prototype.parameters = function () {
        return this.history.location.state;
    };
    NavigationManager.prototype.handleOpenURL = function (e) {
        //FIXME:
        try {
            var route = e.url.replace(/.*?:\/\//g, '');
            var params = route.split("?")[1];
            route = route.split("?")[0];
            this.navigate(route, true, this.parseParams(params));
        }
        catch (error) {
            console.warn("Problem with DeepLinking");
        }
    };
    NavigationManager.prototype.parseParams = function (queryParams) {
        var array = [];
        var params = queryParams.split('&');
        for (var i = 0; i < params.length; i++) {
            var query = params[i].split('=');
            var keyValue = {
                key: query[0],
                value: query[1]
            };
            array.push(keyValue);
        }
        return array;
    };
    return NavigationManager;
}(Manager));
export default NavigationManager;
